module.exports = __webpack_public_path__ + "static/media/car-marker.c099ca03.png";